// extracted by mini-css-extract-plugin
export default {"MultiSelectProductControl":"MultiSelectProductControl_MultiSelectProductControl__790H3","MultiSelectDropdown":"MultiSelectProductControl_MultiSelectDropdown__giepu"};